export default "__VITE_ASSET__554af7bb__"